import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

function EPGDayItem({
  date,
  dayName
}) {
  const dayNumber = date.slice(date.length - 2);

  return (
    <div
      className="epg-dayitem"
    >
      <p className="epg-dayitem__dayname">{dayName.toUpperCase()}</p>
      <strong><p className="epg-dayitem__daynumber">{dayNumber}</p></strong>
    </div>
  );
};

EPGDayItem.propTypes = {
  date: PropTypes.string.isRequired,
  dayName: PropTypes.string.isRequired
};

export default React.memo(EPGDayItem);
